export default {

	mounted()
	{
		if (this.pageData && this.pageData.announcements &&
			this.pageData.announcements.length > 0)
		{
			for (let i = 0; i < this.pageData.announcements.length; i++)
			{
				let block = this.pageData.announcements[i];
				if (block.block_type == "announcement_head")
				{
					// console.log('emiting showTopBanner: ', block);
					// debugger;
					this.$store.commit('setTopBanner', block)
					// this.setTopBanner(block)
					// this.$nextTick( () => this.$root.$emit('showTopBanner', block) )
					break;
				}
			}
		}
	}
}
